import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'

import { FormResponseModel } from '@/domain/model/forms'
import { SelectOptionModel } from '@/domain/model/select'

export const loadFormOptions = async <T>(
  params: T
): Promise<SelectOptionModel[]> => {
  const response = (await makeGetRequest(ApiBase + '/forms/with_pdf', {
    params,
  })) as FormResponseModel

  return response.results.map((item) => ({
    label: item.name,
    value: item.id,
    title: item.type,
  }))
}
